import VModal from 'vue-js-modal'
import Vue from 'vue'
import { FormTextareaPlugin, AlertPlugin, TabsPlugin, SpinnerPlugin } from 'bootstrap-vue'
import Notifications from 'vue-notification'
import ToggleButton from 'vue-js-toggle-button'
import VueShortkey from 'vue-shortkey';

Vue.use(VModal)
Vue.use(FormTextareaPlugin)
Vue.use(AlertPlugin)
Vue.use(TabsPlugin)
Vue.use(Notifications)
Vue.use(ToggleButton)
Vue.use(SpinnerPlugin)
Vue.use(VueShortkey)
